import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    listResources: []
  },
  getters: {
    listResources(state) {
      return state.listResources;
    }
  },
  actions: {
    getListResources({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsToolsRef = db.collection("listings/tools/items");
        let tools = [];

        listingsToolsRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              tools.push({ toolId: doc.id, ...doc.data() });
            });
            commit("SET_LIST_TOOLS", tools);
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        res(tools);
      });
    },
    addResourceIntoSettings(
      { commit, rootState },
      { publishingId, resourceId, propertyName, resourceItem }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${rootState.user.user.uid}/lists/__publishings`
        );
        res(
          publishingsRef
            .get()
            .then(doc => {
              let publishings = [...doc.data().publishings];
              let newPublishings = publishings.map(el => {
                if (el.id === publishingId) {
                  console.log(`found publishing:${el}`);
                  if (el.tools) {
                    let newTools = el.tools.map(aTool => {
                      if (aTool.toolId === resourceId) {
                        if (!aTool.data) aTool.data = {};
                        if (!aTool.data.settings) aTool.data.settings = {};
                        if (!aTool.data.settings[propertyName])
                          aTool.data.settings[propertyName] = [];

                        aTool.data.settings[propertyName].push({
                          ...resourceItem,
                          _created_by: db.doc(
                            `users/${rootState.user.user.uid}`
                          ),
                          _created_at: new Date()
                        });
                      }
                      return aTool;
                    });
                    el.tools = newTools;
                  } else {
                    console.error("No resource to add this to");
                  }
                }
                return el;
              });
              return publishingsRef
                .update({
                  publishings: newPublishings
                })
                .then(resp => {
                  console.log("successfully added video into the publishings");
                });
            })
            .catch(err =>
              console.log(`error in add video into database: ${err}`)
            )
        );
      });
    },
    addResourceIntoSettingsParentProperty(
      { commit, rootState },
      {
        publishingId,
        resourceId,
        parentPropertyName,
        parentPropertyId,
        propertyName,
        resourceItem
      }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${rootState.user.user.uid}/lists/__publishings`
        );
        res(
          publishingsRef
            .get()
            .then(doc => {
              let publishings = [...doc.data().publishings];
              let newPublishings = publishings.map(el => {
                if (el.id === publishingId) {
                  if (el.tools) {
                    let newTools = el.tools.map(aTool => {
                      if (aTool.toolId === resourceId) {
                        if (!aTool.data) aTool.data = {};
                        if (!aTool.data.settings) aTool.data.settings = {};

                        if (parentPropertyName) {
                          //parent one level done
                          if (
                            aTool.data.settings[parentPropertyName] &&
                            Array.isArray(
                              aTool.data.settings[parentPropertyName]
                            )
                          ) {
                            //Must exist
                            //find the item
                            const parentItems = aTool.data.settings[
                              parentPropertyName
                            ].filter(anItem => anItem.id === parentPropertyId);

                            if (
                              parentItems &&
                              Array.isArray(parentItems) &&
                              parentItems[0]
                            ) {
                              const parentItem = parentItems[0];

                              if (
                                !parentItem[propertyName] ||
                                !Array.isArray(parentItem[propertyName])
                              )
                                parentItem[propertyName] = [];
                              parentItem[propertyName].push({
                                ...resourceItem,
                                _created_by: db.doc(
                                  `users/${rootState.user.user.uid}`
                                ),
                                _created_at: new Date()
                              });
                            } else {
                              console.error("Resource not found");
                              return;
                            }
                          } else {
                            console.error("The resource does not exist");
                            return;
                          }
                        } else {
                          //set on settings
                          aTool.data.settings[propertyName] = resourceItem;
                        }
                      }
                      return aTool;
                    });
                    el.tools = newTools;
                  } else {
                    console.error("No resource to add this to");
                  }
                }
                return el;
              });
              return publishingsRef
                .update({
                  publishings: newPublishings
                })
                .then(resp => {
                  console.log("successfully added video into the publishings");
                });
            })
            .catch(err =>
              console.log(`error in add video into database: ${err}`)
            )
        );
      });
    },
    deleteResourceItem(
      { commit, rootState },
      { publishingId, resourceId, propertyName, resourceItem }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${rootState.user.user.uid}/lists/__publishings`
        );
        res(
          publishingsRef
            .get()
            .then(doc => {
              let publishings = [...doc.data().publishings];
              let newPublishings = publishings.map(el => {
                if (el.id === publishingId) {
                  console.log(`found publishing:${el}`);
                  if (el.tools) {
                    let newTools = el.tools.map(aTool => {
                      if (aTool.toolId === resourceId) {
                        if (!aTool.data) aTool.data = {};
                        if (!aTool.data.settings) aTool.data.settings = {};
                        if (!aTool.data.settings[propertyName])
                          aTool.data.settings[propertyName] = [];

                        aTool.data.settings[propertyName].push({
                          ...resourceItem,
                          _created_by: db.doc(`users/${rootState.user.uid}`),
                          _created_at: new Date()
                        });
                      }
                      return aTool;
                    });
                    el.tools = newTools;
                  } else {
                    console.error("No resource to add this to");
                  }
                }
                return el;
              });
              return publishingsRef
                .update({
                  publishings: newPublishings
                })
                .then(resp => {
                  console.log("successfully added video into the publishings");
                });
            })
            .catch(err =>
              console.log(`error in add video into database: ${err}`)
            )
        );
      });
    },
    addVideoIntoResource(
      { commit, rootState },
      { video, publishingId, resourceId }
    ) {
      //,
      //  _created_by: 1, //this.user.uid,
      console.log("addVideoIntoResource");
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(
          `users/${rootState.user.user.uid}/lists/__publishings`
        );
        res(
          publishingsRef
            .get()
            .then(doc => {
              let publishings = [...doc.data().publishings];
              let newPublishings = publishings.map(el => {
                if (el.id === publishingId) {
                  console.log(`found publishing:${el}`);
                  if (el.tools) {
                    let newTools = el.tools.map(aTool => {
                      if (aTool.toolId === resourceId) {
                        if (!aTool.data) aTool.data = {};
                        if (!aTool.data.settings) aTool.data.settings = {};
                        if (!aTool.data.settings.videos)
                          aTool.data.settings.videos = [];
                        aTool.data.settings.videos.push({
                          ...video,
                          _created_by: db.doc(`users/1`)
                        });
                      }
                      return aTool;
                    });
                    el.tools = newTools;
                  } else {
                    console.error("No tool to add this to");
                  }
                }
                return el;
              });
              return publishingsRef
                .update({
                  publishings: newPublishings
                })
                .then(() => {
                  console.log("successfully added video into the publishings");
                });
            })
            .catch(err =>
              console.log(`error in add video into database: ${err}`)
            )
        );
      });
    },
    updateResourceSettings(
      { commit, rootState },
      { settings, publishingId, resourceId, replace }
    ) {
      //,
      //  _created_by: 1, //this.user.uid,
      const userId = rootState.user.user.uid;
      console.log(`addVideoIntoResource for ${userId}`);

      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const publishingsRef = db.doc(`users/${userId}/lists/__publishings`);

        publishingsRef
          .get()
          .then(doc => {
            let publishings = [...doc.data().publishings];
            let newPublishings = publishings.map(el => {
              if (el.id === publishingId) {
                console.log(`found publishing:${el}`);
                if (el.tools) {
                  let newTools = el.tools.map(aTool => {
                    if (aTool.toolId === resourceId) {
                      if (!aTool.data) aTool.data = {};
                      if (!aTool.data.settings) {
                        aTool.data.settings = {};
                        aTool.data.settings = {
                          ...settings,
                          _created_by: db.collection("users").doc(userId),
                          _created_at: new Date()
                        };
                      } else {
                        aTool.data.settings = {
                          ...settings,
                          _updated_by: db.collection("users").doc(userId),
                          _updated_at: new Date()
                        };
                      }
                    }
                    return aTool;
                  });
                  el.tools = newTools;
                } else {
                  console.error("No tool to add this to");
                }
              }
              return el;
            });

            publishingsRef
              .update({
                publishings: newPublishings
              })
              .then(data => {
                console.log("successfully added video into the publishings");
                res({ success: true });
              });
          })
          .catch(err => {
            console.log(`error in add video into database: ${err}`);
            rej(err);
          });
      });
    }
  },
  //synchronous
  mutations: {
    SET_LIST_RESOURCES(state, listTools) {
      if (listTools) {
        state.listTools = listTools;
      } else {
        state.listTools = [];
      }
    }
  }
};
